<template>
  <div class="link-form">
    <div v-if="event" class="label" @click="goto(event)">
      {{label}}
    </div>
    <router-link class="label subhead" v-else :to="to" :target="others" >{{label}}</router-link>
  </div>
</template>

<script>

export default {
  name: 'adx-link-form',
  components: {

  },
  props: {
    to: {
      required: false
    },
    label: {
      required: false
    },
    event: {
      required: false
    },
    others: {
      required: false,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    goto(name) {
      this.$emit('goto', name)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>